import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  goToMenu,
  goToLocationListPage
} from 'bento-ordering/cart/actions/orderSettings';

import Drawer from 'bento-ordering/base/components/Drawer';
import CartContainer from 'bento-ordering/cart/containers/CartContainer';
import ModalContainer from 'bento-ordering/base/containers/ModalContainer';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

class CartDrawer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    previousLocation: PropTypes.object.isRequired
  };

  handleClose = () => {
    if (this.props.previousLocation.pathname === '/') {
      this.props.dispatch(goToLocationListPage());
    } else {
      this.props.dispatch(goToMenu());
    }
  };

  render() {
    const { previousLocation } = this.props;
    return (
      <ModalContainer>
        <Drawer handleClose={this.handleClose}>
          <CartContainer previousLocation={previousLocation} />
        </Drawer>
      </ModalContainer>
    );
  }
}

export default withGoogleLibraryLoaded(connect()(CartDrawer));
